import React from 'react';
import './RetroInput.css';

function RetroInput({
  type = 'text',
  id,
  name,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  label,
  error,
  hint,
  className = '',
  ...props
}) {
  return (
    <div className={`retro-input-wrapper ${className}`}>
      {label && (
        <label htmlFor={id} className="retro-input-label">
          {label}
          {required && <span className="retro-input-required"> *</span>}
        </label>
      )}

      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`retro-input ${error ? 'retro-input-error' : ''} ${disabled ? 'retro-input-disabled' : ''}`}
        {...props}
      />

      {error && <div className="retro-input-error-message">{error}</div>}
      {hint && !error && <div className="retro-input-hint">{hint}</div>}
    </div>
  );
}

export default RetroInput;
